<div id="pricing" class="pricing-area pt-100 pb-70 bg-F7F5F4">
    <div class="container">
        <div class="section-title">
            <h2>Тарифы <span>курса</span></h2>
        </div>
        <div class="row justify-content-center">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="pricingTable tarrif_container">
                    <h3 class="title">Базовый</h3>
                    <div class="price-value">
                        <span class="currency">₽</span>
                        <span class="amount"><s>100.000</s></span>
                        <!--<s></s>-->
                        <span class="discountPrice">90.000</span>
                        <!--<timer></timer>
    <!--<span class="month">/Per month</span>-->
                    </div>
                    <ul class="pricing-content">
                        <li><i class="fas fa-minus"></i> Доступ к информации на период обучения </li>
                        <li><i class="fas fa-minus"></i> Диплом государственного образца <br />о профессиональной переподготовке</li>
                        <li><i class="fas fa-minus"></i> Проверка домашних заданий </li>
                        <li><i class="fas fa-minus"></i> Доступ в закрытый чат</li>
                        <li><i class="fas fa-minus"></i> Чек-листы </li>
                        <li><i class="fas fa-minus"></i> Список литературы и необходимые сайты </li>
                        <!--
        <li><i class="fas fa-check"></i> 30% разовая скидка </li>
        <li><i class="fas fa-check"></i> Доступ на 30 дней к 5 модулям</li>
        <li><i class="fas fa-check"></i> Сертификат ОПОРЫ РОССИИ </li>
        <li><i class="fas fa-check"></i> Доступ к проверенной базе</li>
        <li><i class="fas fa-check"></i> Проверка домашних заданий </li>
        -->
                    </ul>
                    <a routerLink="/" class="btn btn-primary" (click)="showPaymentForm90()">Купить</a>

                    <!--<p style="margin-top: 25px; font-size: 12px; color: #555;">
                        *Промокод можно использовать на сайте Геткурса
                    </p>-->

                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="pricingTable tarrif_container">
                    <h3 class="title">Премиум</h3>
                    <div class="price-value">
                        <span class="currency">₽</span>
                        <span class="amount"><s>170.000</s></span>
                        <span class="discountPrice">150.000</span>
                        <!--<timer></timer>-->
                    </div>
                    <ul class="pricing-content">
                        <li><i class="fas fa-minus"></i> <span class="boldText">Доступ к информации курса на 1 год</span> </li>
                        <li><i class="fas fa-minus"></i> Диплом государственного образца <br />о профессиональной переподготовке</li>
                        <li><i class="fas fa-minus"></i> Доступ к проверенной базе поставщиков, логистов, таможенных кодов, банков</li>
                        <li><i class="fas fa-minus"></i> Проверка домашних заданий </li>
                        <li><i class="fas fa-minus"></i> Доступ в закрытый чат</li>
                        <li><i class="fas fa-minus"></i> <span class="boldText">30% скидка на услуги поиска и доставки товара</span> </li>
                        <li><i class="fas fa-minus"></i> <span class="boldText">Возможность получить карту АТЭС для безвизового въезда в Китай на 5 лет, а также в 18 стран содружества со скидкой в 50 %</span> </li>
                        <li><i class="fas fa-minus"></i> <span class="boldText">Индивидуальная консультация от экспертов</span> </li>
                        <li><i class="fas fa-minus"></i> Чек-листы </li>
                        <li><i class="fas fa-minus"></i> Список литературы и необходимые сайты </li>
                        <!--
                        <li><i class="fas fa-check"></i> 30% разовая скидка </li>
                        <li><i class="fas fa-check"></i> Доступ на 30 дней к 10 модулям</li>
                        <li><i class="fas fa-check"></i> Сертификат ОПОРЫ РОССИИ </li>
                        <li><i class="fas fa-check"></i> Доступ к проверенной базе</li>
                        <li><i class="fas fa-check"></i> Доступ к чату с бизнес-аналитиками </li>
                        <li><i class="fas fa-check"></i> Проверка домашних заданий </li>
                        <li><i class="fas fa-check"></i> Индивидуальная консультация от экспертов </li>
                        <li><i class="fas fa-check"></i> Список проверенной литературы </li>
                        -->
                    </ul>
                    <a routerLink="/" class="btn btn-primary" (click)="showPaymentForm130()">Купить</a>

                      <!--<p style="margin-top: 25px; font-size: 12px; color: #555;">
                          *Промокод можно использовать на сайте Геткурса
                      </p>-->
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="pricingTable tarrif_container">
                    <h3 class="title">ВИП</h3>
                    <div class="price-value">
                        <span class="currency">₽</span>
                        <span class="amount"><s>300.000</s></span>
                        <span class="discountPrice">260.000</span>
                        <!--<timer></timer>-->
                    </div>
                    <ul class="pricing-content">
                        <li><i class="fas fa-minus"></i> Доступ к информации курса <span class="boldText">бессрочно</span></li>
                        <li><i class="fas fa-minus"></i> Диплом государственного образца <br />о профессиональной переподготовке</li>
                        <li><i class="fas fa-minus"></i> Доступ к проверенной базе поставщиков, логистов, таможенных кодов, банков </li>
                        <li><i class="fas fa-minus"></i> Проверка домашних заданий</li>
                        <li><i class="fas fa-minus"></i> Доступ в закрытый чат </li>
                        <li><i class="fas fa-minus"></i> 30% скидка на услуги поиска и доставки товара </li>
                        <li><i class="fas fa-minus"></i> Возможность <span class="boldText">бесплатно</span> получить карту АТЭС для безвизового въезда в Китай на 5 лет, а также в 18 стран содружества </li>
                        <li><i class="fas fa-minus"></i> Индивидуальная консультация от экспертов </li>
                        <li><i class="fas fa-minus"></i> Чек-листы  </li>
                        <li><i class="fas fa-minus"></i> Список литературы и необходимые сайты </li>
                        <li> <span class="boldText">+</span> </li>
                        <li><i class="fas fa-minus"></i> <span class="boldText">Вип-чат с экспертом</span> </li>
                        <li><i class="fas fa-minus"></i> <span class="boldText">2 Индивидуальных разбора вашего кейса</span>  </li>


                    </ul>
                    <a routerLink="/" class="btn btn-primary" (click)="showPaymentForm230()">Купить</a>

                    <!--<p style="margin-top: 25px; font-size: 12px; color: #555;">
                        *Промокод можно использовать на сайте Геткурса
                    </p>-->
                </div>
            </div>
        </div>
    </div>
    <div class="shape1"><img src="assets/img/shape1.png" alt="image"></div>
</div>
